module.exports = __webpack_public_path__ + "static/squirrel-172669f6fd15019ebb45743a5b34bbf9.png";